export default function Button({
    children,
    onClick,
    type = "button",
    className = "",
    disabled = false,
    variant = "primary",
}) {
    const baseStyles =
        "font-bold transition-colors duration-200 uppercase text-sm";

    const variants = {
        primary: "py-2 px-3 bg-primary rounded-md text-text-light hover:bg-secondary",
        secondary: "py-2 px-3 bg-transparent border-2 border-primary text-primary rounded-md hover:bg-primary hover:text-text-light",
        danger: "py-2 px-3 bg-primary rounded-md text-text-light hover:bg-red-700",
        icon: "p-2.5 bg-transparent border-2 border-primary text-primary rounded-full hover:bg-primary hover:text-text-light h-fit",
        ghost: "rounded-md text-primary hover:text-secondary p-0 m-0 tracking-wide text-right",

    };

    const disabledStyles = "px-3 py-2 bg-primaryLt rounded-md text-secondary cursor-not-allowed opacity-70";

    return (
        <button
            type={type}
            onClick={!disabled ? onClick : undefined}
            disabled={disabled}
            className={`${baseStyles} ${disabled ? disabledStyles : variants[variant]
                } ${className}`}
        >
            {children}
        </button>
    );
}
